import { Action } from 'redux';
import { ANNOUNCEMENTS_FETCH } from 'src/modules/announcements/actions/AnnouncementsActions';
import { AnnouncementsState } from 'src/modules/announcements/types/AnnouncementsState';

export function announcementsFetchReducer(state: AnnouncementsState, action: Action): AnnouncementsState {
  if (ANNOUNCEMENTS_FETCH.is(action)) {
    return {
      announcements: action.data,
    };
  }

  return state;
}
